import Sidebar from "../components/marketplace/Sidebar";
import CampaignMarketplace from "../components/marketplace/CampaignMarketplace";

/*
Purpose:
Main dashboard for creators.

Creators can:
• discover campaigns
• bid on campaigns
• manage their promotions
*/

export default function CreatorDashboard() {

  return (

    <div className="flex min-h-screen bg-yellow-200">

      <Sidebar />

      <div className="flex-1 p-8">

        <h1 className="text-3xl text-white font-bold mb-8">
          Creator Dashboard
        </h1>

        <CampaignMarketplace />

      </div>

    </div>

  );
}